import { useState } from "react";
import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS, ENTITY_NAMES } from "@miplatform/constants";
import { mdiPlus } from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { StepTemplateCard } from "../components/StepTemplateCard";
import { StepTemplateModal } from "../components/StepTemplateModal";

export const StepTemplatesTab = ({
  stepTemplates,
  updateItem,
  createItem,
  handleDelete,
}) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleCreate = (data) => {
    createItem(data);
    setShowCreateModal(false);
  };

  const openCreateModal = () => setShowCreateModal(true);

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box display="flex" justifyContent="flex-end">
        <MiButton
          onClick={openCreateModal}
          title="Template Item"
          variant={BUTTON_VARIANTS.CONTAINED}
          startIcon={{
            path: mdiPlus,
          }}
        />
      </Box>
      <Box overflow="auto" flex="1">
        {stepTemplates?.length > 0 ? (
          stepTemplates.map((item) => (
            <StepTemplateCard
              item={item}
              key={item.id}
              handleDelete={handleDelete}
              updateItem={updateItem}
            />
          ))
        ) : (
          <Typography>
            No {ENTITY_NAMES.STEP_TEMPLATES.toLowerCase()} found
          </Typography>
        )}
      </Box>
      {showCreateModal && (
        <StepTemplateModal
          open={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onSubmit={handleCreate}
          templateItem={null}
        />
      )}
    </Box>
  );
};
